export const ngbLargeModalOptions: any = {
    backdrop: 'static',
    keyboard: false,
    class: 'Parametertemplate'
};

export const ngbMediumModalOptions: any = {
    backdrop: 'static',
    keyboard: false,
    class: 'Mediumtemplate'
};

export const ngbModalOptions: any = {
    backdrop: 'true',
    keyboard: false
};
